import {CompetitionPageMetaDataModel} from "../../../models/competition-page.meta-data.model";
import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";

export class CompetitionTransfersPageRouteMetaDataModel extends CompetitionPageMetaDataModel {
  @computed get pageTitle() {
    let title = this.staticTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(METADATA_FILTERS.COMPETITION.transfers)
    }

    return title
  }

  @computed get description(): String {
    let description = this.staticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(METADATA_FILTERS.COMPETITION.transfers)
    }

    return description
  }

  get staticTitle() {
    const staticTitle = this.websiteTerms.COMPETITION_TRANSFERS_TITLE_TEMPLATE.format({
      COMPETITION_NAME: this.competitionName,
    });

    return staticTitle
  }

  get staticDescription() {
    const staticDescription = this.websiteTerms.COMPETITION_TRANSFERS_DESCRIPTION_TEMPLATE.format({
      "COMPETITION_NAME": this.competitionName,
      "SPORT_TYPE": this.competitionSportName
    });

    return staticDescription;
  }
}